import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Poster from './Poster';
import EventDetails from './EventDetails';
import Tabs from './Tabs';
import BackButton from '../../../components/BackButton';
import "../../../styles/EventPage.scss"
import { tryFetch, IResponse } from "../../../helpers/FetchAPI";


interface Ticket {
  id: string;
  event_id: string;
  name: string;
  description: string;
  capacity: number;
  ticket_price: string;
  created_at: string;
}

interface HouseRule {
  id: string;
  rule: string;
}

interface Event {
  id: string;
  event_type: string;
  event_title: string;
  event_slug: string;
  event_image: string;
  venue: string;
  all_dates: string[] | null;
  description: string;
  organizer: string;
  venue_type: string;
  venue_image: string;
  tickets: Ticket[];
  house_rules: HouseRule[];
  status: string;
  time_limit_minutes: number | null;
  is_seat_section: string;
  created_at: string;
  event_rating: string;
  event_url?: string;
}

const EventPage: React.FC = () => {
  // const { id } = useParams();
  const { slug } = useParams();
  const location = useLocation();
  const [eventData, setEventData] = useState<Event | null>(null);
  const eventId = location.state?.eventId;
  

   useEffect(() => {
    const fetchEvent = async () => {
  try {
    if (!eventId) {
      console.error("Event ID not found from navigation state.");
      setEventData(null);
      return;
    }

    const response: IResponse = await tryFetch({
      url: `/events/${eventId}`,
      method: "GET",
    });

    if (response && response.is_success && response.data) {
      const event = response.data as Event;

      setEventData({
        ...event,
        event_image: event.event_image || "/assets/event-def.png",
      });
    } else {
      console.error("Failed to fetch event:", response?.error || "Unknown error");
      setEventData(null);
    }
  } catch (error) {
    console.error("Error fetching event:", error);
    setEventData(null);
  }
};

    fetchEvent();
  }, [eventId, slug]);

  if (!eventData) return <div>Loading...</div>;

  return (
    <div className="event-page">
      <BackButton /> 
      <div className="event-main-section">
      <div className="event-left">
      <Poster image={eventData.event_image} title={eventData.event_title} />
       </div>
       <div className="event-right">
      <EventDetails
        event_id={eventData.id}
        title={eventData.event_title}
        date={eventData.all_dates}
        venue={eventData.venue}
        event_rating={eventData.event_rating}
        price={eventData.tickets[0]?.ticket_price || ""}
        event_url={eventData.event_url}
        event_slug={eventData.event_slug}
      />
      </div>
      </div>
     <Tabs
        description={eventData.description}
        beneficiary={""}
        organizer={eventData.organizer}
        mapUrl={eventData.venue_image}
        tickets={eventData.tickets || [] } 
        rules={eventData.house_rules || [] }
        all_dates={eventData.all_dates || [] }
      />

    </div>
  );
};

export default EventPage;
